export const HomepageController = () => {
  if(!$('body').hasClass('home')) {
    return;
  }
  let headerHeight = $('.header').height();
  let mainController = new ScrollMagic.Controller();

  let timeline_leafBGClip;
  let timeline_leafTextEnter;
  let timeline_leafBGGrow;
  let timeline_leafTextExit;
  let timeline_highlightedCase;


  enquire.register('screen and (min-width:990px)', {

    match : () => {
      mainController = new ScrollMagic.Controller();
      // timeline.kill();
      timeline_leafBGClip = new TimelineMax();
      timeline_leafTextEnter = new TimelineMax();
      timeline_leafBGGrow = new TimelineMax();
      timeline_leafTextExit = new TimelineMax();
      timeline_highlightedCase = new TimelineMax();

      toggleTransparentHeader(headerHeight);
      sectionSwipe(mainController, headerHeight);
      leafBGClip(mainController, timeline_leafBGClip);
      leafTextEnter(mainController, timeline_leafTextEnter);
      leafBGGrow(mainController, timeline_leafBGGrow);
      leafTextExit(mainController, timeline_leafTextExit);
      // industries(mainController, headerHeight);
      highlightedCase(mainController, timeline_highlightedCase);
    },

    unmatch : () => {
      mainController.destroy(true);
      mainController = null;

      timeline_leafBGClip.kill();
      timeline_leafTextEnter.kill();
      timeline_leafBGGrow.kill();
      timeline_leafTextExit.kill();
      timeline_highlightedCase.kill();

      $('.section, .section div, .section article').removeAttr('style');
    }
  });


}


const toggleTransparentHeader = (headerHeight) => {
  let headerController = new ScrollMagic.Controller();
  const $intro = $('#hp-intro');
  const height = $intro.outerHeight();

  new ScrollMagic.Scene({
    triggerElement: $intro,
    triggerHook: 0,
    offset: -(headerHeight),
    duration: height
  })
  .on('enter leave', function (e) {
    $('body').toggleClass('clear-header');
  })
  .addTo(headerController);
}


const sectionSwipe = (controller, headerHeight) => {
  const $sections = $('.section-swipe');

	$sections.each((i, el) => {
    const height = $(el).outerHeight();
    let offset = -(headerHeight);
    let duration = (height);
    let pushFollow = false;

    if($(el).hasClass('hp-intro')) {
      offset = 0;
    }

    if($(el).hasClass('leaf-title')) {
      duration = (height);
    }

    // if($(el).hasClass('title-block-2')) {
    //   offset = 400,
    //   duration = (height);
    //   pushFollow = true;
    // }

    // if($(el).hasClass('industries-block')) {
    //   duration = (height * 3);
    // }

    if($(el).hasClass('highlighted-case-block')) {

      offset = -(headerHeight);
      duration = (height * 1.4);
      // pushFollow = false;

    }

    if($(el).hasClass('title-block-3')) {

      duration = (height);
      pushFollow = false;
    }


		new ScrollMagic.Scene({
				triggerElement: el,
				triggerHook: 'onLeave',
        offset: offset,
				duration: duration
			})
      // .addIndicators({
      //   colorTrigger: "purple",
      //   colorStart: "green",
      //   colorEnd: "red",
      //   indent: 0,
      //   name: "swipe"})
      .setPin(el, { pushFollowers: pushFollow })
			.addTo(controller);
	})
}


const leafBGClip = (controller, timeline) => {

  const height = $("#leaf-title").outerHeight();
  const tween1 = TweenMax.from("#hp-block-title-2-content, #hp-block-title-2-dummy-leaf", 1, {
    xPercent: -100
  });

  const tween2 = TweenMax.to("#hp-block-title-2-content, #hp-block-title-2-dummy-leaf", 1, {
    xPercent: 0,
    yPercent: 0
  });


  timeline.add(tween1).add(tween2);

  new ScrollMagic.Scene({
      triggerElement: "#leaf-title",
      triggerHook: 0,
      offset: 0,
      duration: height
    })
    // .addIndicators({
    //   colorTrigger: "purple",
    //   colorStart: "green",
    //   colorEnd: "red",
    //   indent: 0,
    //   name: "BG Clip"}) // add indicators (requires plugin)
    .setTween(timeline)
    .addTo(controller);
}


const leafTextEnter = (controller, timeline) => {
  const height = $("#leaf-title").outerHeight();
  const tween1 = TweenMax.from("#hp-block-title-2-content-inner", 1, {
    xPercent: 100
  });

  const tween2 = TweenMax.to("#hp-block-title-2-content-inner", 1, {
    xPercent: 0
  });

  timeline.add(tween1).add(tween2);

  new ScrollMagic.Scene({
      triggerElement: "#leaf-title",
      triggerHook: 0,
      offset: 0,
      duration: height
    })
    .setTween(timeline)
    .addTo(controller);
}


const leafTextExit = (controller, timeline) => {
  const height = $("#leaf-title").outerHeight();

  const tween = TweenMax.to("#hp-block-title-2-content-text", 1, {
    y: -400,
    opacity: 0
  });

  timeline.add(tween);

  new ScrollMagic.Scene({
      triggerElement: "#hp-industries",
      triggerHook: .7,
      offset: 0,
      duration: 300
    })
    // .addIndicators({
    //   colorTrigger: "purple",
    //   colorStart: "green",
    //   colorEnd: "red",
    //   indent: 0,
    //   name: "textExit"}) // add indicators (requires plugin)
    .setTween(timeline)
    .on("leave", function(e) {


      if(e.scrollDirection === 'FORWARD') {
        $('#hp-block-title-2').removeClass('no-clip');
      } else {
        $('#hp-block-title-2').removeClass('no-clip');
      }

    })
    .on("enter", function(e) {
      $('#hp-block-title-2').addClass('no-clip');
    })
    .addTo(controller);
}


const leafBGGrow = (controller, timeline) => {
  const height = $("#hp-block-title-2").outerHeight();
  const tween1 = TweenMax.from("#hp-block-title-2-dummy-leaf", 1, {
    scale: 1,
    y: 0
  });

  const tween2 = TweenMax.to("#hp-block-title-2-dummy-leaf", 1, {
    scale: 2.5,
    y: -200
  });


  timeline.add(tween1).add(tween2);

  new ScrollMagic.Scene({
      triggerElement: "#leaf-title",
      triggerHook: 0,
      offset: height / 5,
      duration: 400
    })
    // .addIndicators({
    //   colorTrigger: "purple",
    //   colorStart: "green",
    //   colorEnd: "red",
    //   indent: 0,
    //   name: "grow"}) // add indicators (requires plugin)
    .setTween(timeline)
    .addTo(controller);
}


const industries = (controller, headerHeight) => {
  const industryDiv = document.getElementById('hp-industries')
  new ScrollMagic.Scene({
    triggerElement: industryDiv,
    triggerHook: 0,
    offset: -(headerHeight),
    duration: $(industryDiv).height() / 3
  })
  // .addIndicators({
  //     colorTrigger: "purple",
  //     colorStart: "green",
  //     colorEnd: "red",
  //     indent: 0,
  //     name: "shrink"}) // add indicators (requires plugin)
  .setPin(industryDiv, { pushFollowers: false })
  .addTo(controller);
}

const imageShrink = (controller, headerHeight, timeline) => {
  const height = $("#hp-industries-image").height();
  const tween1 = TweenMax.from("#hp-industries-image", 1, {
    width: '100vw',
    left: 0,
    yPercent: 0
  });

  const tween2 = TweenMax.to("#hp-industries-image", 1, {
    width: '500px'
  });

  timeline.add(tween1).add(tween2);

  new ScrollMagic.Scene({
      triggerElement: "#hp-industries",
      triggerHook: 0,
      offset: -(headerHeight + 20),
      duration: height
    })
    .setTween(timeline)
    // .addIndicators({
    //   colorTrigger: "purple",
    //   colorStart: "green",
    //   colorEnd: "red",
    //   indent: 0,
    //   name: "shrink"}) // add indicators (requires plugin)
    .addTo(controller);
}

const highlightedCase = (controller, timeline) => {
  const height = $("#hp-case").height();

  const tween1 = TweenMax.from("#hp-case", 1, {
    paddingTop: '200px'
  });

  const tween2 = TweenMax.to("#hp-case", 1, {
    paddingTop: '100px'
  });

  const tween3 = TweenMax.from("#hp-case .highlighted-case", 1, {
    y: '200px'
  });

  const tween4 = TweenMax.to("#hp-case .highlighted-case", 1, {
    y: '100px'
  });

  timeline.add(tween3).add(tween4);

  new ScrollMagic.Scene({
      triggerElement: "#hp-case",
      triggerHook: 0.7,
      offset: 0,
      duration: 100
    })
    // .addIndicators({
    //   colorTrigger: "purple",
    //   colorStart: "green",
    //   colorEnd: "red",
    //   indent: 0,
    //   name: "shrink"}) // add indicators (requires plugin)
    .setTween(timeline)
    .addTo(controller);
}

const highlightedCaseCase = (controller, timeline) => {
  const height = $("#hp-case").height();
  const tween1 = TweenMax.from("#hp-case .highlighted-case", 1, {
    yPercent: -30
  });

  const tween2 = TweenMax.to("#hp-case .highlighted-case", 1, {
    yPercent: 0
  });

  timeline.add(tween1).add(tween2);

  new ScrollMagic.Scene({
      triggerElement: "#hp-case",
      triggerHook: 0.5,
      offset: 0,
      duration: height
    })
    .setTween(timeline)
    .addTo(controller);
}


const textBlock3 = (controller, timeline) => {

  const height = $('#hp-case').height();

  const tween1 = TweenMax.from("#hp-block-title-3", 1, {
    y: '300px'
  });

  const tween2 = TweenMax.to("#hp-block-title-3", 1, {
    y: 0
  });

  timeline.add(tween1).add(tween2);

  new ScrollMagic.Scene({
      triggerElement: "#hp-block-title-3",
      triggerHook: .5,
      offset: -(height / 2),
      duration: (height)
    })
    // .addIndicators({
    //   colorTrigger: "purple",
    //   colorStart: "green",
    //   colorEnd: "red",
    //   indent: 0,
    //   name: "shrink"}) // add indicators (requires plugin)
    .setTween(timeline)
    .addTo(controller);
}



// WEBPACK FOOTER //
// ./src/js/controllers/HomepageController.js